import { EventBroker } from "./types";

enum AppNotificationsEvents {
  notificationDismissed = "notificationDismissed",
}

type AppNotificationsEvent = {
  type: AppNotificationsEvents.notificationDismissed;
  data: string;
};

interface AppNotificationsEventDispatcher {
  dispatchAppNotificationDismissal(key: string): void;
}

function createAppNotificationsEventDispatcher(
  broker: EventBroker,
): AppNotificationsEventDispatcher {
  return {
    dispatchAppNotificationDismissal: (key) =>
      broker.sendEvent({
        type: AppNotificationsEvents.notificationDismissed,
        data: key,
      }),
  };
}

export type { AppNotificationsEvent, AppNotificationsEventDispatcher };

export { AppNotificationsEvents, createAppNotificationsEventDispatcher };
